import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tidy-impact-pill',
  templateUrl: './impact-pill.component.html',
  styleUrls: ['./impact-pill.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class ImpactPillComponent {
  @Input() label = '';
  @Input() impactClass = '';
}
